const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaUnidade: [],
    listaTipo: [],
    listaVencido: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PROCESSO_LOGISTICA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'PROCESSO_LOGISTICA_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'PROCESSO_LOGISTICA_VENCIDO_LISTADO':
            return { ...state, listaVencido: action.payload.data };

        case 'PROCESSO_LOGISTICA_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
            };

        case 'PROCESSO_LOGISTICA_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
            };
                      
        default:
            return state;
    }
}
